import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { subcontractPaymentNeedsReview } from '../../lib/subcontractWorkspace';

const STEP = {
  submitted: { zh: "待 PM 现场验收", en: "Awaiting PM acceptance" },
  pm_approved: { zh: "待工程经理复核", en: "Awaiting eng. review" },
  finance_pending: { zh: "待财务打印支票", en: "Awaiting check print" },
  finance_approved: { zh: "待财务打印支票", en: "Awaiting check print" },
  check_issued: { zh: "待财务打印支票", en: "Awaiting check print" },
  paid: { zh: "已付", en: "Paid" },
  rejected: { zh: "已驳回", en: "Rejected" },
};

/* 付款计划行：在途付款申请当前步骤 + 「等我处理」高亮 + 去付款审批队列 */
export function PayReqChip({ req, zh, role, ms }) {
  const s = STEP[req.status];
  if (!s || req.status === "paid") return null;
  const mine = subcontractPaymentNeedsReview(req, role);
  return (
    <Link to={`/payments?req=${req.id}`} data-testid={`sub-ms-payreq-${ms.id}`} data-status={req.status} data-mine={mine ? 1 : 0} onClick={(e) => e.stopPropagation()}
      title={zh ? "打开付款审批队列处理该申请" : "Open payment queue"}
      className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full border flex-shrink-0 ${mine ? "bg-red-50 text-red-700 border-red-300 ring-2 ring-red-100" : "bg-violet-50 text-violet-800 border-violet-200"}`}>
      <Clock className="h-3 w-3" />{zh ? s.zh : s.en}{mine ? (zh ? " · 等我处理" : " · mine") : ""}<ArrowRight className="h-3 w-3" />
    </Link>
  );
}
